import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomValidator } from './custom-from-validators';
import { ParentService } from '../parent.service';
import { error } from 'jquery';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-parentapp-login',
  templateUrl: './parentapp-login.component.html',
  styleUrls: ['./parentapp-login.component.scss']
})
export class ParentappLoginComponent implements OnInit {
  parentform: FormGroup;
  showpassword: boolean = false;
  isFormInvalid: boolean = false;
  isvalid: boolean = false;
  parentdetails: any;
  parenttoken: any;
  parentadmno: any;
  errorDescription: string;
  constructor(private fb: FormBuilder, private parenthttp: ParentService, private spinner: NgxSpinnerService, private router: Router) { }
  ngOnInit(): void {
    this.parentform = this.fb.group({
      admissionNumber: ['', [Validators.required, CustomValidator.numberValidator]],
      mobileNo: ['', [Validators.required, CustomValidator.numberValidator]],
      Date: ['', Validators.required],
    });
  }
  toggleshow() {
    this.showpassword = !this.showpassword;
  }

  submit() {
    if (this.parentform.valid) {
      const payload = {
        "admNo": this.parentform.value.admissionNumber,
        "mobileNo": this.parentform.value.mobileNo,
        "dateOfBirth": moment(this.parentform.value.Date).format("DD-MM-YYYY")
      }
      this.spinner.show();
      this.parenthttp.parentlogin(payload).subscribe(
        {
          next: (res: any) => {
            this.parentdetails = res;
            // console.log('parent-token', this.parentdetails);
            this.parenttoken = this.parentdetails.map.accessToken
            this.parentadmno = this.parentdetails.map.studentUniqueRefNo
            localStorage.setItem('token', this.parenttoken);
            localStorage.setItem('studentUniqueRefNo', this.parentadmno);
            localStorage.setItem('url',environment.employeeURL+"/jwtV2/student/app")
            this.spinner.hide();
            this.router.navigate(['parent/studentProgressReport']);
          },
          error: (error: any) => {
            // console.log(error.error);
            this.errorDescription = error.error
            this.spinner.hide();
          }
        }
      );
    }
    else {
      this.isFormInvalid = true;
    }
  }


}
